import UriBuilder from "./module.uribuilder";
import { format as formatDate } from '../fields/recordm.fields.date.js';
import { format as formatDateTime } from '../fields/recordm.fields.datetime.js';
import { format as formatFile } from '../fields/recordm.fields.file.js';
import { format as formatNumber } from '../fields/recordm.fields.number.js';
import utils from "../../cob/ui-genesis/cob.utils";

const getIndexFieldName = function (fieldName){
    return fieldName.toLowerCase().replace(/\s+/g, '_');
};

//returns the value formatted according to its description (e.g.: $number, $date, $link)
// * `displayValue`: the field value to format
// * `rawValue`: the original field value
// e.g.: $refs have both "<ref_field>" and "<ref_field>_reference" fields
//     * "<ref_field>" = referenced instance id = rawValue (used to build the URI for the referenced instance)
//     * "<ref_field>_reference" = referenced instance $instanceLabel field = displayValue (used as the visible $ref field value)
const format = function(displayValue, rawValue, description, fieldDefId, instanceId, locale) {
    var isNumber;

    if (!displayValue || displayValue.length === 0) {
        return "";
    }

    if (!description) {
        return displayValue;
    }

    // We evaluate $ref fields in first place because there may be fields that are both $ref and another field type
    // and we want them to be formatted as $refs (eg: Field = $ref $date)
    if((/\$ref\(/).test(description)){
        // Format the field value without the $ref keyword, as it can have multiple field type keywords
        const formattedValue = format(displayValue, rawValue, description.replace(/\$ref/g, ""), fieldDefId, instanceId);
        return `<a href="#/instance/${rawValue}" class="link" target="_blank">${formattedValue}</a>`;
    }

    isNumber = (/\$number(\((\d+)\))?/).exec(description);

    if (isNumber) {
        return formatNumber(displayValue, isNumber[2] !== undefined && isNumber[2] > 0, isNumber[2], locale);

    } else if ((/\$datetime/).test(description)) {
        return formatDateTime(displayValue, locale);

    } else if ((/\$date/).test(description)) {
        return formatDate(displayValue, locale);

    } else if ((/\$link|\$create/).test(description)) {
        return '<a href="' + encodeURI(displayValue) + '" class="link" target="_blank">Link</a>';

    } else if ((/\$tasks/).test(description)) {
        if(displayValue.state === 'complete'){
            return null;
        }

        return `${displayValue.date ? ` <span class='rm-task-date'>${formatDate(displayValue.date, locale)}</span>`:''}
               ${displayValue.name}
               ${displayValue.assignee ? ` <span class='rm-task-assignee'>${displayValue.assignee}</span>`:''}`;

    } else if((/\$file|\$extFile/).test(description)){
        // if displayValue is different we have an _uri field and can use it
        if(displayValue !== rawValue) {
            const baseUri = UriBuilder.buildBaseUriForInstanceFiles(instanceId);
            return formatFile(baseUri, rawValue, displayValue);
        }
        const baseUri = UriBuilder.buildBaseUriForInstanceFile(instanceId, fieldDefId);
        return formatFile(baseUri, displayValue);

    }

    // By default we ensure it is safe to include the value in HTML elements
    return utils.encodeHTML(displayValue);
};

export { format, getIndexFieldName };
